import React, {Component} from 'react';
import ReactDOM from 'react-dom'
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import HeaderHomeTwo from "../../components/header-home-two/component";
import countryCodes from "country-telephone-data";
import scrollToComponent from 'react-scroll-to-component';
import ModalVideo from "../../components/modal-video/component";
import ModalLang from "../../components/modal-lang/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import BoosterFooter from "../../components/booster-footer/component";
import BoosterHeader from "../../components/booster-header/component";
import {dataRegister} from "../../services/dataRegister";
import ModalVip from "../../components/modal-vip/component";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class BoosterReseller extends Component {

    constructor(props) {
        super(props);
        this.state = {
            terms: false,
            isLoadingButton: false,
            countries: [],
            country: null,
            video: false,
            vip: false,
            form_validation: {},
            first_name: "",
            last_name: "",
            search: ""
        };
        this.signupRef = React.createRef();
        this._setVip = this._setVip.bind(this);
    };

    componentDidMount() {
        this._updateCountries();
        if(this.props.location.search === "?scrolldown=signup"){
            scrollToComponent(this.signupRef.current, { offset: 0, duration: 500});
        }else{
            window.scrollTo(0, 0);
        }

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/reseller');
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }
    }

    _updateCountries() {
        let countries = JSON.parse(JSON.stringify(countryCodes.allCountries));
        for (let i = 0; i < countries.length; i++) {
            countries[i].dialCode = "+" + countries[i].dialCode;
            if (countries[i].iso2 ===  salesChannelRegister.get("market")) {
                this._selectCountry(countries[i]);
            }
        }
        this.setState({countries: countries});
    }

    _apply(){

        for (let key in this.state.form_validation) {
            this.state.form_validation[key] = false;
        }

        //CHECK VALUES
        this.state.form_validation.first_name = this.state.first_name === "" || !this.state.first_name;
        this.state.form_validation.last_name = this.state.last_name === "" || !this.state.last_name;
        this.state.form_validation.company = this.state.company === "" || !this.state.company;
        this.state.form_validation.address = this.state.address === "" || !this.state.address;
        this.state.form_validation.zip = this.state.zip === "" || !this.state.zip;
        this.state.form_validation.city = this.state.city === "" || !this.state.city;
        this.state.form_validation.country_name = this.state.country_name === "" || !this.state.country_name;
        this.state.form_validation.website = !this._urlValidation(this.state.website);
        this.state.form_validation.email = !this._emailValidation(this.state.email);
        this.state.form_validation.phone = !this._phoneValidation(this.state.phone);

        try{
            this.state.form_validation.dialcode = !this.state.country.dialCode;
        }catch (e) {
            this.state.form_validation.dialcode = true;
        }

        this.setState({form_validation: this.state.form_validation});

        //CHECK IF TERMS IS SET
        if(!this.state.terms){return}

        let result = false;
        for (let key in this.state.form_validation) {
            if (this.state.form_validation[key]) {
                result = true;
                break;
            }
        }
        if(!result){
            this.setState({isLoadingButton: true});
            let information = {
                first_name: this.state.first_name,
                last_name: this.state.last_name,
                company: this.state.company,
                address: this.state.address,
                zip: this.state.zip,
                city: this.state.city,
                country_name: this.state.country_name,
                website: this.state.website,
                email: this.state.email,
                phone: (this.state.country.dialCode&&this.state.phone!=="")?(this.state.country.dialCode + this.state.phone):this.state.phone,
            };
            let data = {email: this.state.email, name: JSON.stringify(information), subject: salesChannelRegister.get('name') + " user request", message: salesChannelRegister.get("market")};
            dataRegister.industryRequest(salesChannelRegister.get("market"), salesChannelRegister.get('name'), data).then((response) => {
                this.setState({
                    isLoadingButton: false,
                    vip: true,
                    first_name: "",
                    last_name: "",
                    company: "",
                    address: "",
                    zip: "",
                    city: "",
                    country_name: "",
                    website: "",
                    email: "",
                    phone: "",
                    terms: false
                });

                //GOOGLE EVENT
                if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                    ReactGA.event({category: 'User', action: 'Applied Reseller', label: 'Reseller'});
                    //console.log("Fire event VIP");
                }

                //FACEBOOK EVENT
                if(dataRegister.api.primehit !== "https://api.devprimehit.com/v1"){
                    ReactPixel.trackCustom('ApplyReseller');
                }

            }, (error) => {
                this.setState({isLoadingButton: false});
            });
        }

    }

    _scrollTo(){
        scrollToComponent(this.signupRef.current, { offset: -150, duration: 500});
    }

    _selectCountry(option) {
        this.setState({country: option, search: option.dialCode}, () => {
            console.log(this.state.country);
        });
    }

    _setVip(value){
        this.setState({vip: value});
    }

    _terms(){
        window.open('https://legal.'+dataRegister.domain+"/"+salesChannelRegister.get("market")+ "/" + langRegister.lang() +"/terms/"+salesChannelRegister.get('name'), '_blank');
    }

    _emailValidation(email) {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    }

    _urlValidation(url) {
        var re = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/;
        return re.test(String(url).toLowerCase());
    }

    _phoneValidation(number) {
        var re = /^[0-9 +]+$/;
        if (re.test(String(number).toLowerCase()) && number.length > 5) {
            return true
        } else {
            false
        }
    }

    _renderText(item) {
        return langRegister.get("reseller", item);
    }

    render() {
        return (
              <div className={Styles.view}>
                  {
                      this.state.vip &&
                      <ModalVip setVip={this._setVip} props={this.props}/>
                  }
                  <BoosterHeader view={"about"} props={this.props}/>
                  <div className={Styles.sectionTwo}>
                      <div className={Styles.sectionTwoInner}>
                          <div className={Styles.sectionTwoText}>
                              {this._renderText("item_31")}
                              <div className={Styles.sectionTwoTextSubtitle}>
                                  {this._renderText("item_32")}
                              </div>
                              <div className={Styles.sectionTwoTextSmall}>
                                  {this._renderText("item_33")}
                              </div>
                              <div className={Styles.sectionTwoTextBullets}>
                                  <div className={Styles.sectionTwoTextBulletsItem}>
                                      {
                                          salesChannelRegister.get('name') === "yieldlock" &&
                                          <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_YL_darkblue.png")}/>
                                      }
                                      {
                                          salesChannelRegister.get('name') === "propertybooster" &&
                                          <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_reseller.png")}/>
                                      }
                                      {
                                          salesChannelRegister.get('name') === "boostabostad" &&
                                          <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_boostabostad.png")}/>
                                      }
                                    <div className={Styles.sectionTwoTextBulletsItemText}>
                                        {this._renderText("item_34")}
                                    </div>
                                  </div>
                                  <div className={Styles.sectionTwoTextBulletsItem}>
                                      {
                                          salesChannelRegister.get('name') === "yieldlock" &&
                                          <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_YL_darkblue.png")}/>
                                      }
                                      {
                                          salesChannelRegister.get('name') === "propertybooster" &&
                                          <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_reseller.png")}/>
                                      }
                                      {
                                          salesChannelRegister.get('name') === "boostabostad" &&
                                          <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_boostabostad.png")}/>
                                      }
                                      <div className={Styles.sectionTwoTextBulletsItemText}>
                                          {this._renderText("item_35")}
                                      </div>
                                  </div>
                                  <div className={Styles.sectionTwoTextBulletsItem}>
                                      {
                                          salesChannelRegister.get('name') === "yieldlock" &&
                                          <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_YL_darkblue.png")}/>
                                      }
                                      {
                                          salesChannelRegister.get('name') === "propertybooster" &&
                                          <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_reseller.png")}/>
                                      }
                                      {
                                          salesChannelRegister.get('name') === "boostabostad" &&
                                          <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_boostabostad.png")}/>
                                      }
                                      <div className={Styles.sectionTwoTextBulletsItemText}>
                                          {this._renderText("item_36")}
                                      </div>
                                  </div>
                                  <div className={Styles.sectionTwoTextBulletsItem}>
                                      {
                                          salesChannelRegister.get('name') === "yieldlock" &&
                                          <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_YL_darkblue.png")}/>
                                      }
                                      {
                                          salesChannelRegister.get('name') === "propertybooster" &&
                                          <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_reseller.png")}/>
                                      }
                                      {
                                          salesChannelRegister.get('name') === "boostabostad" &&
                                          <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_boostabostad.png")}/>
                                      }
                                      <div className={Styles.sectionTwoTextBulletsItemText}>
                                          {this._renderText("item_37")}
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div className={Styles.sectionTwoImage}>
                              {
                                  salesChannelRegister.get('name') === "yieldlock" &&
                                  <img className={Styles.sectionTwoImageItem} src={require("../../assets/images/YL_lock-1.png")}/>
                              }
                              {
                                  salesChannelRegister.get('name') === "propertybooster" &&
                                  <img className={Styles.sectionTwoImageItem} src={require("../../assets/images/PB_megafon.png")}/>
                              }
                              {
                                  salesChannelRegister.get('name') === "boostabostad" &&
                                  <img className={Styles.sectionTwoImageItem} src={require("../../assets/images/BB_megafon.png")}/>
                              }
                          </div>
                      </div>
                  </div>
                  <div ref={this.signupRef} className={Styles.sectionThree}>
                      <div className={Styles.sectionThreeInnerTop}>
                          <div className={Styles.sectionThreeText}>
                              {this._renderText("item_38")}&nbsp;<span className={Styles.sectionThreeTextGreen}>{this._renderText("item_39")}</span>
                          </div>
                      </div>
                      <div className={Styles.sectionThreeInnerBottom}>
                          <div className={Styles.sectionThreeSubtitle}>
                              {this._renderText("item_40")}
                          </div>
                          <div className={Styles.sectionThreeDivider}>
                              <div className={Styles.sectionThreeDividerTitle}>
                                  {this._renderText("item_15")}
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({first_name: event.target.value})} style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={cx(Styles.input)} value={this.state.first_name} placeholder={this._renderText("item_16")}/>
                                  {
                                      this.state.form_validation.first_name &&
                                      <div style={salesChannelRegister.get('name') === "yieldlock"?{borderColor: '#E65032'}:{}} className={Styles.inputError}/>
                                  }
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({last_name: event.target.value})} style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={cx(Styles.input)} value={this.state.last_name} placeholder={this._renderText("item_17")}/>
                                  {
                                      this.state.form_validation.last_name &&
                                      <div style={salesChannelRegister.get('name') === "yieldlock"?{borderColor: '#E65032'}:{}} className={Styles.inputError}/>
                                  }
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({company: event.target.value})} style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={cx(Styles.input)} value={this.state.company} placeholder={this._renderText("item_18")}/>
                                  {
                                      this.state.form_validation.company &&
                                      <div style={salesChannelRegister.get('name') === "yieldlock"?{borderColor: '#E65032'}:{}} className={Styles.inputError}/>
                                  }
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({address: event.target.value})} style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={cx(Styles.input)} value={this.state.address} placeholder={this._renderText("item_19")}/>
                                  {
                                      this.state.form_validation.address &&
                                      <div style={salesChannelRegister.get('name') === "yieldlock"?{borderColor: '#E65032'}:{}} className={Styles.inputError}/>
                                  }
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({zip: event.target.value})} style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={cx(Styles.input)} value={this.state.zip} placeholder={this._renderText("item_20")}/>
                                  {
                                      this.state.form_validation.zip &&
                                      <div style={salesChannelRegister.get('name') === "yieldlock"?{borderColor: '#E65032'}:{}} className={Styles.inputError}/>
                                  }
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({city: event.target.value})} style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={cx(Styles.input)} value={this.state.city} placeholder={this._renderText("item_21")}/>
                                  {
                                      this.state.form_validation.city &&
                                      <div style={salesChannelRegister.get('name') === "yieldlock"?{borderColor: '#E65032'}:{}} className={Styles.inputError}/>
                                  }
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({country_name: event.target.value})} style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={cx(Styles.input)} value={this.state.country_name} placeholder={this._renderText("item_22")}/>
                                  {
                                      this.state.form_validation.country_name &&
                                      <div style={salesChannelRegister.get('name') === "yieldlock"?{borderColor: '#E65032'}:{}} className={Styles.inputError}/>
                                  }
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({website: event.target.value.toLowerCase()})} style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={cx(Styles.input)} value={this.state.website} placeholder={this._renderText("item_23")}/>
                                  {
                                      this.state.form_validation.website &&
                                      <div style={salesChannelRegister.get('name') === "yieldlock"?{borderColor: '#E65032'}:{}} className={Styles.inputError}/>
                                  }
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input onChange={(event) => this.setState({email: event.target.value.toLowerCase()})} style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={cx(Styles.input)} value={this.state.email} placeholder={this._renderText("item_24")}/>
                                  {
                                      this.state.form_validation.email &&
                                      <div style={salesChannelRegister.get('name') === "yieldlock"?{borderColor: '#E65032'}:{}} className={Styles.inputError}/>
                                  }
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <div className={Styles.inputDividerItemInner}>
                                      <div className={Styles.inputDividerItemInnerDropdown}>
                                          <input
                                              placeholder={this._renderText("item_42")}
                                              type="tel"
                                              onFocus={() => this.setState({dropdown: true})}
                                              onBlur={() => this.setState({dropdown: false})}
                                              value={this.state.search}
                                              onChange={(event) => this.setState({search: event.target.value}, () => {
                                                  if(this.state.search !== this.state.country.dialCode){
                                                      console.log(this.state.country.dialCode);
                                                      this.setState({country: {}});
                                                  }
                                              })}
                                              style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}}
                                              className={Styles.inputDividerItemInnerDropdownInput}
                                          />
                                          {
                                              this.state.dropdown && this.state.countries.filter((item) => {
                                                  return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                              }).length > 0 &&
                                              <div className={Styles.dropdownList}>
                                                  {
                                                      this.state.countries.filter((item) => {
                                                          return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                                      }).map((prop, key) => {
                                                          return (
                                                              <div key={key}
                                                                   onMouseDown={() => this._selectCountry(prop)}
                                                                   style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}} className={Styles.dropdownListItem}>
                                                                  {prop.dialCode}
                                                              </div>
                                                          )
                                                      })
                                                  }
                                              </div>
                                          }
                                          {
                                              this.state.form_validation.dialcode &&
                                              <div style={salesChannelRegister.get('name') === "yieldlock"?{borderColor: '#E65032'}:{}} className={Styles.inputError}/>
                                          }
                                      </div>
                                      <div className={Styles.inputDividerItemInnerInput}>
                                          <input
                                              type="tel"
                                              value={this.state.phone}
                                              onChange={(e) => {
                                                  const re = /^[0-9\b]+$/;
                                                  if (e.target.value === '' || re.test(e.target.value)) {
                                                      this.setState({phone: e.target.value.trim()})
                                                  }
                                              }}
                                              style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}}
                                              className={Styles.input}
                                              placeholder={this._renderText("item_25")}
                                          />
                                          {
                                              this.state.form_validation.phone &&
                                              <div style={salesChannelRegister.get('name') === "yieldlock"?{borderColor: '#E65032'}:{}} className={Styles.inputError}/>
                                          }
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div className={Styles.inputDividerItem}>
                              <div className={Styles.checkMarksContainerItem}>
                                  {
                                      !this.state.terms &&
                                      <img onClick={() => this.setState({terms: true})}
                                           src={require("../../assets/images/square_checkmark_two.svg")}
                                           className={Styles.checkMarksContainerItemIcon}/>
                                  }
                                  {
                                      salesChannelRegister.get('name') === "propertybooster" &&
                                      this.state.terms &&
                                      <img onClick={() => this.setState({terms: false})}
                                           src={require("../../assets/images/square_checkmark_active_pb.svg")}
                                           className={Styles.checkMarksContainerItemIcon}/>
                                  }
                                  {
                                      salesChannelRegister.get('name') === "boostabostad" &&
                                      this.state.terms &&
                                      <img onClick={() => this.setState({terms: false})}
                                           src={require("../../assets/images/square_checkmark_active_bb.svg")}
                                           className={Styles.checkMarksContainerItemIcon}/>
                                  }
                                  {
                                      salesChannelRegister.get('name') === "yieldlock" &&
                                      this.state.terms &&
                                      <img onClick={() => this.setState({terms: false})}
                                           src={require("../../assets/images/square_checkmark_active_yl.svg")}
                                           className={Styles.checkMarksContainerItemIcon}/>
                                  }
                                  <div className={Styles.checkMarksContainerItemText}>
                                      {this._renderText("item_29")} <span onClick={() => this._terms()} className={Styles.checkMarksContainerItemTextBold}>{this._renderText("item_30")}</span>
                                  </div>
                              </div>
                          </div>
                          <div onClick={() => this._apply()} className={Styles.sectionThreeButton}>
                              {this._renderText("item_26")}
                          </div>
                          <div className={Styles.sectionThreeButtonText}>
                              {this._renderText("item_27")} <span onClick={() => this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/login")} className={Styles.sectionThreeButtonTextBold}>{this._renderText("item_28")}</span>
                          </div>
                      </div>
                  </div>
                  <BoosterFooter props={this.props}/>
              </div>
        );
    }

    /*
     <div className={Styles.sectionThree}>
                      <div className={Styles.sectionThreeText}>
                          {this._renderText("item_7")}
                          <span className={Styles.sectionThreeTextGreen}>{this._renderText("item_8")}</span>
                          {this._renderText("item_9")}
                          <br className={Styles.sectionThreeTextBreak}/>
                          <span className={Styles.sectionThreeTextGreen}>{this._renderText("item_10")}</span>
                          <br className={Styles.sectionThreeTextBreak}/>
                          {this._renderText("item_11")}
                          <div className={Styles.sectionThreeTextSmall}>
                              {this._renderText("item_12")}
                          </div>
                          <div className={Styles.sectionThreeButton}>
                              {this._renderText("item_13")}
                          </div>
                      </div>
                      <div className={Styles.sectionThreeFiller}/>
                      <div className={Styles.sectionThreeImage}>
                          <img className={Styles.sectionThreeImageItem}
                               src={require("../../assets/images/AB_illustration_cards.png")}/>
                      </div>
                  </div>
     */
}

export default BoosterReseller;


// WEBPACK FOOTER //
// ./src/pages/booster-reseller/component.js